module.exports = __webpack_public_path__ + "static/jade3-5e1dda3d7a57de37ce614a4d38b5f517.png";